window.addEventListener("load", function () {
    
    // Search functionality
    function initSearch() {
        var $searchInput = $('#cfl-ld-creator-list #search-input');
        var $searchButton = $('#cfl-ld-creator-list #search');
        var $grList = $('#cfl-ld-creator-list .gr_list');
        
        if (!$searchInput.length || !$grList.length) return;

        function performSearch() {
            var searchTerm = $searchInput.val().trim().toLowerCase();
            var isMobile = window.innerWidth <= 768;
            
            // If swiper is initialized, destroy it first to get all items
            if ($grList.data('swiper-initialized') || $grList.hasClass('swiper')) {
                if ($grList[0].swiper) {
                    $grList[0].swiper.destroy(true, true);
                }
                $grList.removeClass('swiper creator-list-swiper');
                
                // Get all items from swiper structure before removing it
                var $swiperSlides = $grList.find('.swiper-slide');
                var $itemsInSlides = $swiperSlides.find('.item');
                
                // Restore items to grList
                $itemsInSlides.each(function() {
                    var $item = $(this);
                    $item.detach();
                    $grList.append($item);
                });
                
                // Remove swiper structure
                $grList.find('.swiper-wrapper').remove();
                $grList.find('.swiper-button-next, .swiper-button-prev').remove();
                $swiperSlides.remove();
                $grList.data('swiper-initialized', false);
            }
            
            // Get all items (excluding those still in swiper structure if any)
            var $allItems = $grList.find('.item:not(.swiper-slide .item)');
            
            // If no items found, try to get all items (maybe swiper wasn't initialized or items are direct children)
            if ($allItems.length === 0) {
                $allItems = $grList.find('.item');
            }
            var hasResults = false;

            // Filter items based on search term
            $allItems.each(function() {
                var $item = $(this);
                var $nameElement = $item.find('.name');
                var name = $nameElement.text().trim().toLowerCase();
                
                if (searchTerm === '' || name.includes(searchTerm)) {
                    $item.show();
                    hasResults = true;
                } else {
                    $item.hide();
                }
            });
            
            // If search term is empty, ensure all items are visible
            if (searchTerm === '') {
                $allItems.show();
                hasResults = true;
            }

            // Re-initialize pagination and swiper after search
            setTimeout(function() {
                initPagination();
                initCreatorListSwiper();
            }, 100);
        }

        // Search on input change
        $searchInput.on('input', function() {
            performSearch();
        });

        // Search on button click
        $searchButton.on('click', function(e) {
            e.preventDefault();
            performSearch();
        });

        // Search on Enter key
        $searchInput.on('keypress', function(e) {
            if (e.which === 13) {
                e.preventDefault();
                performSearch();
            }
        });
    }

    // Pagination functionality (desktop only)
    function initPagination() {
        var $grList = $('#cfl-ld-creator-list .gr_list');
        var $pagination = $('#cfl-ld-creator-list .pm__pagination');
        if (!$grList.length || !$pagination.length) return;

        // Hide pagination on mobile, show on desktop
        var isMobile = window.innerWidth <= 768;
        if (isMobile) {
            $pagination.hide();
            // Don't show all items - respect search filter
            // Only show items that are already visible (not hidden by search)
            return;
        }

        $pagination.show();

        var itemsPerPage = 6;
        var currentPage = 1;
        var $filteredItems = null; // Store items after search filter

        // Function to get all items (excluding swiper slides) - not filtered by visibility
        function getAllItems() {
            return $grList.find('.item:not(.swiper-slide .item)');
        }

        // Function to get items that should be visible (not hidden by search filter)
        // This refreshes the filtered items list by getting all items that are currently visible
        // (before pagination hides them)
        function refreshFilteredItems() {
            var $allItems = getAllItems();
            // First, temporarily show all items to see which ones should be visible (not hidden by search)
            var filtered = [];
            
            $allItems.each(function() {
                var $item = $(this);
                var originalDisplay = $item.css('display');
                
                // Temporarily show the item
                $item.css('display', '');
                $item.show();
                
                // Check if it's actually visible (not hidden by search filter or CSS)
                // If it's visible now, it means it should be included in pagination
                if ($item.is(':visible') && $item.css('display') !== 'none') {
                    filtered.push(this);
                }
                
                // Restore original display state
                $item.css('display', originalDisplay);
            });
            
            $filteredItems = $(filtered);
            return $filteredItems;
        }

        // Function to show items for current page
        function showPage(page) {
            currentPage = page;
            
            // Check if mobile (re-check on each call)
            var isMobileNow = window.innerWidth <= 768;
            
            // On mobile, don't hide/show items (let Swiper handle it)
            if (!isMobileNow) {
                // Use stored filtered items (items that should be paginated)
                var $items = $filteredItems && $filteredItems.length > 0 
                    ? $filteredItems 
                    : getAllItems();
                
                var totalItems = $items.length;
                var startIndex = (page - 1) * itemsPerPage;
                var endIndex = startIndex + itemsPerPage;

                // Show/hide items based on pagination
                $items.each(function(index) {
                    if (index >= startIndex && index < endIndex) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });
            }

            // Update pagination UI
            updatePaginationUI();
        }

        // Function to update pagination controls
        function updatePaginationUI() {
            $pagination.empty();

            // Use stored filtered items, or refresh if not available
            var $items = $filteredItems && $filteredItems.length > 0 
                ? $filteredItems 
                : refreshFilteredItems();
            
            // If still no items, use all items
            if ($items.length === 0) {
                $items = getAllItems();
            }
            
            var totalItems = $items.length;
            var totalPages = Math.ceil(totalItems / itemsPerPage);

            // Page number buttons
            var maxVisiblePages = 5;
            var startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
            var endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
            
            if (endPage - startPage < maxVisiblePages - 1) {
                startPage = Math.max(1, endPage - maxVisiblePages + 1);
            }

            if (startPage > 1) {
                var $firstLi = $('<li class="page-item"></li>');
                var $firstLink = $('<a class="page-link" href="javascript:void(0)">1</a>');
                $firstLink.on('click', function(e) {
                    e.preventDefault();
                    showPage(1);
                });
                $firstLi.append($firstLink);
                $pagination.append($firstLi);

                if (startPage > 2) {
                    var $ellipsis = $('<li class="page-item disabled"><span class="page-link">...</span></li>');
                    $pagination.append($ellipsis);
                }
            }

            for (var i = startPage; i <= endPage; i++) {
                var $li = $('<li class="page-item"></li>');
                var $link = $('<a class="page-link" href="javascript:void(0)">' + i + '</a>');
                
                if (i === currentPage) {
                    $li.addClass('active');
                } else {
                    $link.on('click', function(e) {
                        e.preventDefault();
                        var page = parseInt($(this).text());
                        showPage(page);
                    });
                }
                
                $li.append($link);
                $pagination.append($li);
            }

            if (endPage < totalPages) {
                if (endPage < totalPages - 1) {
                    var $ellipsis = $('<li class="page-item disabled"><span class="page-link">...</span></li>');
                    $pagination.append($ellipsis);
                }

                var $lastLi = $('<li class="page-item"></li>');
                var $lastLink = $('<a class="page-link" href="javascript:void(0)">' + totalPages + '</a>');
                $lastLink.on('click', function(e) {
                    e.preventDefault();
                    showPage(totalPages);
                });
                $lastLi.append($lastLink);
                $pagination.append($lastLi);
            }
        }

        // Initialize: get all items that are currently visible (after search, before pagination)
        // This captures the state before pagination starts hiding items
        var $allItems = getAllItems();
        var visibleBeforePagination = [];
        
        // Get all items that are visible (not hidden by search)
        $allItems.each(function() {
            var $item = $(this);
            // If item is visible, it means it passed the search filter
            if ($item.is(':visible') && $item.css('display') !== 'none') {
                visibleBeforePagination.push(this);
            }
        });
        
        // Store the filtered items list (items that should be paginated)
        $filteredItems = $(visibleBeforePagination);
        
        // If no filtered items, use all items
        if ($filteredItems.length === 0) {
            $filteredItems = $allItems;
        }
        
        var totalItems = $filteredItems.length;
        
        if (totalItems > 0) {
            showPage(1);
        } else {
            $pagination.hide();
        }
    }

    // Initialize Swiper for mobile only
    function initCreatorListSwiper() {
        var $grList = $('#cfl-ld-creator-list .gr_list');
        if (!$grList.length) return;

        if (window.innerWidth <= 768) {
            // If already initialized on mobile, return
            if ($grList.data('swiper-initialized')) {
                return;
            }

            // If was on desktop, destroy first
            if ($grList[0].swiper) {
                $grList[0].swiper.destroy(true, true);
                $grList.removeClass('swiper creator-list-swiper');
                $grList.find('.swiper-wrapper').remove();
                $grList.find('.swiper-button-next, .swiper-button-prev').remove();
                var $swiperSlides = $grList.find('.swiper-slide');
                var $items = $swiperSlides.find('.item');
                $items.each(function() {
                    var $item = $(this);
                    $item.detach();
                    $grList.append($item);
                });
                $swiperSlides.remove();
                $grList.data('swiper-initialized', false);
            }

            if (typeof Swiper !== 'undefined') {
                // Get visible items only (respect search filter)
                var $items = $grList.find('.item:not(.swiper-slide .item):visible');
                if ($items.length === 0) return;

                // Create swiper wrapper
                var $swiperWrapper = $('<div class="swiper-wrapper"></div>');
                var $swiperNext = $('<div class="swiper-button-next"></div>');
                var $swiperPrev = $('<div class="swiper-button-prev"></div>');

                // Group 3 items into each slide (vertical layout in each slide)
                var itemsArray = $items.toArray();
                for (var i = 0; i < itemsArray.length; i += 3) {
                    var $slide = $('<div class="swiper-slide"></div>');
                    var $slideContent = $('<div class="slide-items"></div>');
                    
                    // Add up to 3 items to this slide
                    for (var j = 0; j < 3 && (i + j) < itemsArray.length; j++) {
                        var $item = $(itemsArray[i + j]);
                        $slideContent.append($item.detach());
                    }
                    
                    $slide.append($slideContent);
                    $swiperWrapper.append($slide);
                }

                // Add swiper structure
                $grList.addClass('swiper creator-list-swiper');
                $grList.append($swiperWrapper);
                $grList.append($swiperNext);
                $grList.append($swiperPrev);

                // Initialize Swiper
                var swiperInstance = new Swiper('.creator-list-swiper', {
                    direction: 'horizontal',
                    slidesPerView: 1,
                    spaceBetween: 20,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                        }
                    }
                });

                // Mark as initialized
                $grList.data('swiper-initialized', true);
            }
        } else {
            // Desktop: remove swiper structure and restore original items
            if ($grList.data('swiper-initialized')) {
                var swiperInstance = $grList[0].swiper;
                if (swiperInstance) {
                    swiperInstance.destroy(true, true);
                }
                
                // Get items from swiper slides
                var $swiperSlides = $grList.find('.swiper-slide');
                var $items = $swiperSlides.find('.item');
                
                // Remove swiper structure
                $grList.removeClass('swiper creator-list-swiper');
                $grList.find('.swiper-wrapper').remove();
                $grList.find('.swiper-button-next, .swiper-button-prev').remove();
                
                // Restore items to original position
                $items.each(function() {
                    var $item = $(this);
                    $item.detach();
                    $grList.append($item);
                });
                
                // Remove swiper slides and slide-items wrapper
                $swiperSlides.remove();
                
                // Mark as not initialized
                $grList.data('swiper-initialized', false);
            }
        }
    }

    // Initialize on load
    initSearch();
    initPagination();
    initCreatorListSwiper();

    // Re-initialize on resize
    var resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            initPagination();
            initCreatorListSwiper();
        }, 250);
    });
    
    // Make search function accessible globally for re-initialization
    window.reinitCreatorListSearch = function() {
        initSearch();
    };
});
